export default "__VITE_ASSET__DqxwsXG3__"